var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongtick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53329 19.3337L0.666626 17.467L8.13329 10.0003L0.666626 2.53366L2.53329 0.666992L9.99996 8.13366L17.4666 0.666992L19.3333 2.53366L11.8666 10.0003L19.3333 17.467L17.4666 19.3337L9.99996 11.867L2.53329 19.3337Z",
    fill: "#EE6C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongtick);
export default __webpack_public_path__ + "static/media/wrong tick.cdcb1a4fe8623a3a0b27a77b4c47a634.svg";
export { ForwardRef as ReactComponent };